import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                VForm,
                [
                  !_vm.readonly
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { sm: "1", lg: "1" } },
                            [
                              _c(VCheckbox, {
                                staticClass: "mt-0",
                                attrs: {
                                  label: _vm.$t("my_tasks.modals.shared"),
                                  disabled: _vm.readonly,
                                },
                                model: {
                                  value: _vm.showShared,
                                  callback: function ($$v) {
                                    _vm.showShared = $$v
                                  },
                                  expression: "showShared",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "3", lg: "3" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  label: _vm.$t("my_tasks.modals.domain"),
                                  disabled: _vm.readonly || _vm.showShared,
                                  items: _vm.filterDomain,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onChangeDomain()
                                  },
                                },
                                model: {
                                  value: _vm.kdomain,
                                  callback: function ($$v) {
                                    _vm.kdomain = $$v
                                  },
                                  expression: "kdomain",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "3", lg: "3" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  label: _vm.$t("my_tasks.modals.subdomain"),
                                  disabled: _vm.readonly || _vm.showShared,
                                  items: _vm.filterSubDomain,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onChangeSubdomain()
                                  },
                                },
                                model: {
                                  value: _vm.ksubdomain,
                                  callback: function ($$v) {
                                    _vm.ksubdomain = $$v
                                  },
                                  expression: "ksubdomain",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "3", lg: "3" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  label: _vm.$t("my_tasks.tablas_tasks.bterm"),
                                  disabled: _vm.readonly,
                                  items: _vm.filterBusinessTerm,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onChangeBusinessTerm()
                                  },
                                },
                                model: {
                                  value: _vm.kbusiness_term,
                                  callback: function ($$v) {
                                    _vm.kbusiness_term = $$v
                                  },
                                  expression: "kbusiness_term",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "2", lg: "2" } },
                            [
                              _c(
                                VBtn,
                                {
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    small: "",
                                    rounded: "",
                                    color: "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onAddBusinessTerm()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("btns.add_item")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(VDataTable, {
                            staticClass: "table-inca",
                            attrs: {
                              "hide-default-footer":
                                Object.keys(_vm.bterms).length <= 10
                                  ? true
                                  : false,
                              dense: "",
                              items: _vm.bterms,
                              headers: _vm.headers,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.index",
                                fn: function (ref) {
                                  var index = ref.index
                                  return [_vm._v(_vm._s(index + 1))]
                                },
                              },
                              {
                                key: "item.term_description",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "text-green-600 hover:underline",
                                        attrs: {
                                          target: "_blank",
                                          to: {
                                            name: "BusinessTerm",
                                            params: {
                                              id: item.kbusiness_term,
                                              domain: item.organization,
                                            },
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.term_description))]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn-icon-inca",
                                                          attrs: {
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onRemoveBT(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: { small: "" },
                                                        },
                                                        [_vm._v("icon-delete")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("btns.remove_item"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.readonly
        ? _c(
            VRow,
            [
              _c(
                VCol,
                { staticClass: "text-right", attrs: { cols: "12" } },
                [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        type: "submit",
                        outlined: "",
                        dense: "",
                        small: "",
                        rounded: "",
                        color: "secondary",
                      },
                      on: { click: _vm.onSubmit },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("send"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("my_tasks.modals.save_bterms"))),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }